<template>
  <div>
    <ed-form :model="formData">
      <ed-input-select
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        label="Empresa"
        v-model="formData.id_emp"
        :items="lstEmpresa"
        :loading="loadingEmpresa"
        @input="getFuncionario"
        @search="getEmpresa"
        clearable
        remote
      />

      <ed-input-text
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        label="Número do Recibo"
        v-model="formData.busca"
        :disabled="!formData.id_emp ? true : false"
      />

      <div
        class="
          col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12
          text-center
          mt-5
        "
      >
        <ed-button
          type="success"
          label="Consultar Informações no eSocial"
          icon="fa fa-search"
          :disabled="!formData.id_emp || !formData.busca ? true : false"
          @click="consultar"
        />
      </div>
    </ed-form>

    <div class="col-12 mt-5" v-if="formData.strXml">
      <h4><b>Informações no eSocial</b></h4>

      <XmlViewer :xml="formData.strXml" />
    </div>
  </div>
</template>

<script>
import XmlViewer from "vue-xml-viewer";
import { EdForm, EdButton, EdInputSelect, EdInputText } from "template";

export default {
  name: "esocial-lotes-reenviar-email",
  mixins: [],
  components: { XmlViewer, EdForm, EdButton, EdInputSelect, EdInputText },

  props: {
    lstEmpresa: {
      type: [Array],
      default: [],
    },
    loadingEmpresa: {
      type: Boolean,
      default: false,
    },
  },
  inject: ["getEmpresa", "getFuncionario", "getLayout"],
  watch: {
    lstEmpresa: {
      handler: function (newVal) {},
      deep: true,
    },
    loadingEmpresa() {},
  },

  data() {
    return {
      formData: {
        id_emp: null,
        id_fun: null,
        layout: null,
        busca: null,
        strXml: null,
      },
    };
  },

  created() {},

  mounted() {},

  methods: {
    consultar() {
      this.$root.$loading.set(true);
      this.formData.strXml = null;

      this.$root.$request
        .post(
          "esocial/lotes/consultar/" + this.formData.id_emp + "/recibo",
          this.formData
        )
        .then((result) => {
          this.$root.$loading.set(false);

          console.log("result", result);
          if (result.status == 200) {
            this.formData.strXml = result.data;
          } else {
            // this.$alert(result.msg, "Atenção", {
            //   confirmButtonText: "OK",
            // });
          }
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// consulta-recibo.vue?712f4be2